import { css } from "@compiled/react";

export interface UniformInvisibleContentProps {
    content: string;
}

const UniformInvisibleContent = (props: UniformInvisibleContentProps) => {
    return <div css={css({ display: "none" })} data-content={props.content} />;
};

export default UniformInvisibleContent;
